import React, { useState, useEffect } from "react";
import "../../../styles/pageStyles/user/user.css";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { useFormikContext } from "formik";
import Input from "@mui/material/Input";
import config from "../../../config/Config";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import CustomModal from "../../common/modals/CustomModal";
import Typography from "@mui/material/Typography";

const ITEM_HEIGHT = 58;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const UserForm = ({ props }) => {
  const { setFieldValue, values, handleBlur, handleChange, touched, errors } =
    useFormikContext();
  const {
    roles,
    showActive,
    postType,
    isLoading,
    setShowActive,
    setPostType,
    createdUserId,
    setSnackbarMssg,
    setSeverityType,
    setOpenSnackbar,
    userData,
    setUserData,
  } = props;
  const location = useLocation();
  const [customModalOpen, setCustomModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  var tokenStr = localStorage.getItem("access_token");
  useEffect(() => {
    if (location.state) {
      const state = location.state;
      if (state?.userData) {
        setFieldValue("id", state.userData.id);
        setFieldValue("pType", state.userData.pType);
        setFieldValue("first_name", state.userData.first_name);
        setFieldValue("last_name", state.userData.last_name);
        setFieldValue(
          "groups",
          state.userData.groups.map((group) => group.name)
        );
        setFieldValue("email", state.userData.email);
        setFieldValue("username", state.userData.username);
        setFieldValue("is_active", state.userData.is_active);
        setFieldValue("is_locked", state.userData.is_locked);
        setShowActive(!state.userData.is_active);
        if (state.postType) {
          setPostType(state.postType);
        }
      }
    } else if (values) {
      setFieldValue("id", values.id);
      setFieldValue("pType", values.pType);
      setFieldValue("first_name", values.first_name);
      setFieldValue("last_name", values.last_name);
      setFieldValue(
        "groups",
        values.groups.map((group) => group.name)
      );
      setFieldValue("email", values.email);
      setFieldValue("username", values.username);
      setFieldValue("is_active", values.is_active);
      setFieldValue("is_locked", values.is_locked);
      setShowActive(!values.is_active);
    }
  }, [location]);

  useEffect(() => {
    const state = location.state;
    var tokenStr = localStorage.getItem("access_token");
    fetch(`${config.baseUrl}user/${state?.userId}/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${tokenStr}`,
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      const results = await response.json();
      if (response.status === 200 || response.status === 201) {
        setUserData(results);
      } else if (response.status === 403) {
        localStorage.setItem("access_token", "");
        navigate("/");
      }
    });
  }, []);

  const handleModal = () => {
    setCustomModalOpen(!customModalOpen);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  function handleUserActivation() {
    setFieldValue("is_active", false);
    setFieldValue("is_locked", true);
    setLoader(true);
    const id = values.id ? values.id : createdUserId;
    fetch(`${config.baseUrl}user/${id}/`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenStr}`,
      },
      body: JSON.stringify({
        is_active: !values.is_active,
        is_locked: !values.is_locked,
      }),
    })
      .then(async (response) => {
        handleModal();
        const results = await response.json();
        if (response.status === 201 || response.status === 200) {
          setSnackbarMssg("User is activated successfully");
          setSeverityType("success");
          setOpenSnackbar(true);
          await sleep(2000);
          setShowActive(!results.user_info.is_active);
          showActive === false
            ? localStorage.setItem("showActive", false)
            : localStorage.setItem("showActive", true);
          setFieldValue("is_active", results.user_info.is_active);
          setFieldValue("is_locked", results.user_info.is_locked);
          setLoader(false);
        } else if (response.status === 403) {
          localStorage.setItem("access_token", "");
          navigate("/");
          setLoader(false);
        } else {
          if (results.detail) {
            setSnackbarMssg(results.detail);
            setSeverityType("error");
            setOpenSnackbar(true);
            setLoader(false);
          } else {
            setSnackbarMssg("Something went wrong");
            setSeverityType("error");
            setOpenSnackbar(true);
            setLoader(false);
          }
        }
      })
      .catch((error) => {});
  }
  function handleUserDeactivation() {
    setFieldValue("is_active", false);
    setFieldValue("is_locked", true);
    setLoader(true);
    const id = values.id ? values.id : createdUserId;
    fetch(`${config.baseUrl}user/${id}/`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenStr}`,
      },
      body: JSON.stringify({
        is_active: !values.is_active,
        is_locked: !values.is_locked,
      }),
    })
      .then(async (response) => {
        handleModal();
        const results = await response.json();
        if (response.status === 201 || response.status === 200) {
          setSnackbarMssg("User is deactivated successfully");
          setSeverityType("success");
          setOpenSnackbar(true);
          await sleep(2000);
          setShowActive(!results.user_info.is_active);
          showActive === false
            ? localStorage.setItem("showActive", false)
            : localStorage.setItem("showActive", true);
          setFieldValue("is_active", results.user_info.is_active);
          setFieldValue("is_locked", results.user_info.is_locked);
          setLoader(false);
        } else if (response.status === 403) {
          localStorage.setItem("access_token", "");
          navigate("/");
          setLoader(false);
        } else {
          if (results.detail) {
            setSnackbarMssg(results.detail);
            setSeverityType("error");
            setOpenSnackbar(true);
            setLoader(false);
          } else {
            setSnackbarMssg("Something went wrong");
            setSeverityType("error");
            setOpenSnackbar(true);
            setLoader(false);
          }
        }
      })
      .catch((error) => {});
  }

  function deactiveUser() {
    return (
      <>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontFamily: "proxima-semibold" }}
        >
          Are you sure you want to deactivate?
        </Typography>
        <Grid
          container
          spacing={2}
          className="form-layout-btn"
          style={{ justifyContent: "center" }}
        >
          <Button
            className="primary-btn"
            variant="contained"
            color="primary"
            disabled={loader === true}
            onClick={() => handleUserDeactivation()}
          >
            {loader === false ? (
              "Deactivate"
            ) : (
              <CircularProgress
                className="circular_spiner"
                size={24}
                color="white"
              />
            )}
          </Button>
          <Button
            className="primary-btn-cancel"
            variant="outlined"
            color="primary"
            onClick={handleModal}
            style={{ background: "#fff", color: "#067DE2" }}
          >
            Cancel
          </Button>
        </Grid>
      </>
    );
  }

  function activeUser() {
    return (
      <>
        <Typography variant="h6" gutterBottom >
          Are you sure you want to Activate?
        </Typography>
        <Grid
          container
          spacing={2}
          className="form-layout-btn"
          style={{ justifyContent: "center" }}
        >
          <Button
            className="primary-btn"
            variant="contained"
            color="primary"
            disabled={loader === true}
            onClick={handleUserActivation}
          >
            {loader === false ? (
              "Activate"
            ) : (
              <CircularProgress
                className="circular_spiner"
                size={24}
                color="white"
              />
            )}
          </Button>
          <Button
            className="primary-btn-cancel"
            variant="outlined"
            color="primary"
            onClick={handleModal}
            style={{ background: "#fff", color: "#067DE2" }}
          >
            Cancel
          </Button>
        </Grid>
      </>
    );
  }
  return (
    <>
      <Grid
        container
        className="user-form-container"
        columnSpacing={4}
        rowSpacing={2}
      >
        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Grid container className="row form-div">
            <Grid item size={{ xs: 12, sm: 6, md: 5, lg: 5 }}>
              <label>
                Username <span className="asterisk">*</span>
              </label>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 7 }}>
              <TextField
                type="text"
                variant="outlined"
                name="username"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.username}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Grid container className="row form-div">
            <Grid item size={{ xs: 12, sm: 6, md: 5, lg: 5 }}>
              <label>
                Email ID <span className="asterisk">*</span>
              </label>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 7 }}>
              <TextField
                variant="outlined"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                type="text"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Grid container className="row form-div">
            <Grid item size={{ xs: 12, sm: 6, md: 5, lg: 5 }}>
              <label>
                First Name <span className="asterisk">*</span>
              </label>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 7 }}>
              <TextField
                type="text"
                variant="outlined"
                name="first_name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.first_name}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Grid container className="row form-div">
            <Grid item size={{ xs: 12, sm: 6, md: 5, lg: 5 }}>
              <label>
                Last Name <span className="asterisk">*</span>
              </label>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 7 }}>
              <TextField
                type="text"
                variant="outlined"
                name="last_name"
                onChange={handleChange}
                value={values.last_name}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <Grid container className="row form-div">
            <Grid item size={{ xs: 12, sm: 6, md: 5, lg: 5 }}>
              <label>
                Role <span className="asterisk">*</span>
              </label>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 7 }}>
              <Select
                name="groups"
                labelId="mutiple-role-label"
                id="mutiple-role"
                displayEmpty
                multiple
                className="role-select"
                onChange={handleChange}
                value={values.groups}
                input={<Input />}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return (
                      <MenuItem
                        sx={{
                          paddingLeft: "10px",
                          fontFamily: "proxima-regular",
                          fontSize: "14px",
                        }}
                      >
                        ---Select Role---
                      </MenuItem>
                    );
                  }
                  return selected.join(", ");
                }}
                MenuProps={MenuProps}
                sx={{
                  fontFamily: "proxima-regular",
                  fontSize: "14px",
                  "& .MuiMenuItem-root:hover": {
                    backgroundColor: "transparent ",
                  },
                }}
              >
                {roles.map((item) => (
                  <MenuItem key={item.id} value={item.name}>
                    <Checkbox checked={values.groups.indexOf(item.name) > -1} />
                    <ListItemText
                      primary={item.name}
                      sx={{
                        ".MuiTypography-root": {
                          fontFamily: "proxima-regular",
                          fontSize: "14px",
                        },
                      }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
          alignContent="center"
        >
          <Grid container className="row form-div">
            <Grid item size={{ xs: 12, sm: 6, md: 5, lg: 5 }}>
              <label htmlFor="active">Active</label>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 7 }}>
              {showActive === false ? (
                <p
                  id="active"
                  style={{ fontFamily: "proxima-regular", fontSize: "14px" }}
                >
                  Yes
                </p>
              ) : (
                <p
                  id="active"
                  style={{ fontFamily: "proxima-regular", fontSize: "14px" }}
                >
                  No
                </p>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {touched.username ||
      touched.first_name ||
      touched.last_name ||
      touched.groups ? (
        <div
          className="error d-flex justify-end "
          style={{ marginTop: "5px", paddingRight: "10px" }}
        >
          {errors.username}
        </div>
      ) : touched.email ? (
        <div
          className="error d-flex justify-end"
          style={{ marginTop: "5px", paddingRight: "10px" }}
        >
          {errors.email}
        </div>
      ) : (
        ""
      )}
      <Grid container spacing={2} className="btns-flex-end">
        {postType === "create" ? (
          <Button
            className="primary-btn"
            variant="contained"
            onClick={() => {
              setFieldValue("postType", "edit");
            }}
            color="primary"
            name="postType"
            type="submit"
            disabled={isLoading === true}
            value="create"
          >
            {isLoading === false ? (
              "Save"
            ) : (
              <CircularProgress
                className="circular_spiner"
                size={24}
                color="white"
              />
            )}
          </Button>
        ) : (
          <Button
            className="primary-btn"
            variant="contained"
            color="primary"
            disabled={isLoading === true}
            type="submit"
            value="edit"
          >
            {isLoading === false ? (
              "Update"
            ) : (
              <CircularProgress
                className="circular_spiner"
                size={24}
                color="white"
              />
            )}
          </Button>
        )}
        {postType === "create" ? null : showActive === false ? (
          <Button
            className="primary-btn"
            variant="contained"
            color="primary"
            onClick={handleModal}
          >
            Deactivate
          </Button>
        ) : (
          <Button
            className="primary-btn"
            variant="contained"
            color="primary"
            onClick={handleModal}
          >
            Activate
          </Button>
        )}
        <NavLink
          style={{ textDecoration: "none", color: "#067DE2" }}
          exact
          to="/user-listing"
        >
          <Button className="primary-btn-cancel" variant="outlined">
            Cancel
          </Button>
        </NavLink>
      </Grid>
      {showActive === false ? (
        <CustomModal
          open={customModalOpen}
          handleClose={handleModal}
          body={deactiveUser()}
          header="Deactivate User"
        />
      ) : (
        <CustomModal
          open={customModalOpen}
          handleClose={handleModal}
          body={activeUser()}
          header="Activate User"
        />
      )}
    </>
  );
};

export default UserForm;
